var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFavorite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeWidth: 2,
  d: "M17.72 2.2A5.2 5.2 0 0 0 11 3.51a5.3 5.3 0 0 0-6.73-1.33 5.6 5.6 0 0 0-2.5 6.6C2.69 13.09 11 18.5 11 18.5s8.31-5.42 9.23-9.71a5.68 5.68 0 0 0-2.5-6.6Z"
})));
export default SvgFavorite;